const { fetchJSON } = window.BAO.Utils

class ProtectedTemplate extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['form', 'password', 'submit']
  }

  constructor () {
    super()

    this.password = null
  }

  connectedCallback () {
    super.connectedCallback()

    this.fetchPassword()
  }

  setupListeners () {
    super.setupListeners()
    this.listeners.add(
      this.els.form.element,
      'submit',
      this.formSubmit.bind(this),
    )
  }

  async fetchPassword () {
    try {
      const { data } = await fetchJSON(`/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json;',
          'X-Shopify-Storefront-Access-Token':
            window.theme.protectedTemplatesApiAccessToken,
        },
        body: JSON.stringify({
          query: this.getQuery(),
        }),
      })

      this.password = data.metaobject.passwordField.value
    } catch (e) {
      console.error(e)
    }
  }

  async formSubmit (e) {
    e.preventDefault()

    try {
      if (this.password === this.els.password.element.value) {
        await this.setCartAttribute(this.dataset.storageName, 'true')

        location.reload()
      } else {
        this.log('Incorrect password')
      }
    } catch (e) {
      console.error(e)
    }
  }

  async setCartAttribute (attributeKey, attributeValue) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [attributeKey]: attributeValue,
        },
      }),
    })
  }

  getQuery () {
    return `query {
      metaobject(id: "${this.dataset.id}") {
        passwordField: field(key: "password") {
          value
        }
      }
    }`
  }
}

if (!customElements.get('protected-template')) {
  customElements.define('protected-template', ProtectedTemplate)
}
